import React from 'react';
import { GeneralInfo } from 'features/profile/component/general-info/general-info';

/**
 * Account Tab Component
 * 
 * A settings tab component that displays account information and security settings.
 * This tab is used within the SettingsDialog to provide account details,
 * profile management, and security options.
 * 
 * Features:
 * - User profile information
 * - Account security settings (2FA, password)
 * - Account management options
 * - Integration with the existing settings dialog structure
 * - Responsive design that works on both desktop and mobile
 * 
 * @param tabId - The ID of the current tab (used for consistency with other tabs)
 * @returns An account information tab component
 */

interface AccountTabProps {
    tabId: string;
}

export const AccountTab: React.FC<AccountTabProps> = () => {
    return (
        <div className="h-full overflow-auto bg-background">
            <div className="px-4 sm:px-6 md:px-8 py-4 sm:py-5 max-w-4xl">
                <GeneralInfo />
            </div>
        </div>
    );
};

